import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { FormattedDate, FormattedMessage } from 'react-intl';
import {
  FieldBasic,
  DividerFullWidth as Divider,
} from '@mummssoftware/common-ui';
import styled from 'styled-components';
import { getFontSize, getUpdatedClassName } from './utils';
import messages from '../CertMessages';
import { dateFormat, FORM_PHYS_VERBAL_DATE } from '../../../constants';
// todo common-ui
const DatesDiv = styled.div`
  display: flex;
`;

const DetailColumn = styled.div`
  margin-left: 15px;
`;

const VerbalDiv = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const captionStyle = { flexBasis: '100%' };

export const CertHeader = ({
  classes,
  headerGrids,
  benStartDate,
  benEndDate,
  formPhysVerbalDate,
  updates,
  verbalTakenBy,
  smallWidget,
  certPhysName,
  admitDate,
  currentCert,
  historicalView,
}) =>
  smallWidget ? (
    <Grid
      className={classes.gridContainer}
      style={{ whiteSpace: 'pre' }}
      item
      container
      direction="column"
      xs={12}
    >
      <DatesDiv>
        <DetailColumn>
          <FieldBasic
            key="payer-name"
            style={smallWidget ? { fontSize: '14px' } : {}}
            classes={classes}
            gridProps={headerGrids}
            label={
              <FormattedMessage
                key="payer-name-label"
                {...messages.payerName}
              />
            }
            data={currentCert?.carrierName || ''}
          />
          <FieldBasic
            key="ben-admission"
            style={smallWidget ? { fontSize: '14px' } : {}}
            classes={classes}
            gridProps={headerGrids}
            label={
              <FormattedMessage
                key="ben-admission-label"
                {...messages.benADMDate}
              />
            }
            data={<FormattedDate value={admitDate} {...dateFormat} />}
          />
        </DetailColumn>
        <DetailColumn>
          <FieldBasic
            key="ben-start"
            style={smallWidget ? { fontSize: '14px' } : {}}
            classes={classes}
            gridProps={headerGrids}
            label={
              <FormattedMessage
                key="ben-start-label"
                {...messages.benStartDate}
              />
            }
            data={<FormattedDate value={benStartDate} {...dateFormat} />}
          />
          <FieldBasic
            key="ben-end"
            style={smallWidget ? { fontSize: '14px' } : {}}
            classes={classes}
            gridProps={headerGrids}
            label={
              <FormattedMessage key="ben-end-label" {...messages.benEndDate} />
            }
            data={<FormattedDate value={benEndDate} {...dateFormat} />}
          />
        </DetailColumn>
        {formPhysVerbalDate ? (
          <DetailColumn>
            <FieldBasic
              key="verb-date"
              style={smallWidget ? { fontSize: '14px' } : {}}
              classes={classes}
              gridProps={headerGrids}
              label={
                <FormattedMessage
                  key="verbal-date-label"
                  {...messages.verbalDate}
                />
              }
              data={
                <FormattedDate value={formPhysVerbalDate} {...dateFormat} />
              }
              DataTypographyProps={{
                className: getUpdatedClassName(
                  classes,
                  updates,
                  FORM_PHYS_VERBAL_DATE,
                ),
              }}
            />
          </DetailColumn>
        ) : null}
      </DatesDiv>
      <VerbalDiv>
        {verbalTakenBy && verbalTakenBy !== certPhysName ? (
          <Typography variant="caption" style={captionStyle}>
            <FormattedMessage
              {...messages.verbalOrderBy}
              values={{ takenBy: verbalTakenBy, phys: certPhysName }}
            />
          </Typography>
        ) : null}
        {verbalTakenBy && verbalTakenBy === certPhysName ? (
          <Typography variant="caption" style={captionStyle}>
            <FormattedMessage
              {...messages.verbalOrderSignedBy}
              values={{ phys: certPhysName }}
            />
          </Typography>
        ) : null}
      </VerbalDiv>
      <Divider style={{ width: '100%' }} />
    </Grid>
  ) : (
    <Grid
      className={classes.gridContainer}
      style={{ whiteSpace: 'pre' }}
      container
      direction="row"
      justifyContent="space-between"
    >
      <Grid item sm={3}>
        <FieldBasic
          key="payer-name"
          style={{ fontSize: getFontSize(smallWidget, historicalView) }}
          classes={classes}
          gridProps={headerGrids}
          label={
            <FormattedMessage key="payer-name-label" {...messages.payerName} />
          }
          data={currentCert?.carrierName || ''}
        />
        <FieldBasic
          key="ben-admission"
          style={{ fontSize: getFontSize(smallWidget, historicalView) }}
          classes={classes}
          gridProps={headerGrids}
          label={
            <FormattedMessage
              key="ben-admission-label"
              {...messages.benADMDate}
            />
          }
          data={<FormattedDate value={admitDate} {...dateFormat} />}
        />
      </Grid>
      <Grid item sm={3}>
        <FieldBasic
          key="ben-start"
          style={{ fontSize: getFontSize(smallWidget, historicalView) }}
          classes={classes}
          gridProps={headerGrids}
          label={
            <FormattedMessage
              key="ben-start-label"
              {...messages.benStartDate}
            />
          }
          data={<FormattedDate value={benStartDate} {...dateFormat} />}
        />
        <FieldBasic
          key="ben-end"
          style={{ fontSize: getFontSize(smallWidget, historicalView) }}
          classes={classes}
          gridProps={headerGrids}
          label={
            <FormattedMessage key="ben-end-label" {...messages.benEndDate} />
          }
          data={<FormattedDate value={benEndDate} {...dateFormat} />}
        />
      </Grid>
      {formPhysVerbalDate ? (
        <Grid item container {...headerGrids} direction="row-reverse" sm={3}>
          <FieldBasic
            key="verb-date"
            style={{
              fontSize: getFontSize(smallWidget, historicalView),
            }}
            classes={classes}
            label={
              <FormattedMessage
                key="verbal-date-label"
                {...messages.verbalDate}
              />
            }
            data={<FormattedDate value={formPhysVerbalDate} {...dateFormat} />}
            DataTypographyProps={{
              className: getUpdatedClassName(
                classes,
                updates,
                FORM_PHYS_VERBAL_DATE,
              ),
            }}
          />
          {verbalTakenBy && verbalTakenBy !== certPhysName ? (
            <Typography
              variant="caption"
              style={{
                ...captionStyle,
                fontSize: getFontSize(smallWidget, historicalView),
              }}
              paragraph
            >
              <FormattedMessage
                {...messages.verbalOrderBy}
                values={{ takenBy: verbalTakenBy, phys: certPhysName }}
              />
            </Typography>
          ) : null}
          {verbalTakenBy && verbalTakenBy === certPhysName ? (
            <Typography
              variant="caption"
              style={{
                ...captionStyle,
                fontSize: getFontSize(smallWidget, historicalView),
              }}
              paragraph
            >
              <FormattedMessage
                {...messages.verbalOrderSignedBy}
                values={{ phys: certPhysName }}
              />
            </Typography>
          ) : null}
        </Grid>
      ) : null}
      <Divider style={{ width: '100%' }} />
    </Grid>
  );
